const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Le Karithé – masque les titres d'avis qui ne sont qu'une date technique (import Loox) */
;(function(){var re=/^\s*\d{4}-\d{2}-\d{2}T\d{2}:\d{2}[\d:.]*Z?\s*$/,q=0;function t(){q=0;document.querySelectorAll('.jdgm-widget,[class*="jm-review"]').forEach(function(root){var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT),n;while((n=w.nextNode())){if(re.test(n.nodeValue)&&n.parentElement&&n.parentElement.tagName!=='SCRIPT'&&n.parentElement.style.display!=='none'){n.parentElement.style.display='none';}}});}function go(){t();new MutationObserver(function(){if(!q){q=1;requestAnimationFrame(t);}}).observe(document.body,{childList:true,subtree:true,characterData:true});}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',go);}else{go();}})();
